
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft, faArrowRight, faChevronRight, faChevronLeft, faEllipsisH, faPlus, faMinus, faTimes, faCaretDown, faCaretRight, faFlag, faLandmark, faCity, faList, faMapMarkedAlt, faSort, faSortUp, faSortDown, faSearch, faFilter, faMapMarkerAlt, faUserCircle, faPhoneAlt, faEnvelope, faUpload, faRedo, faCheckSquare, faCheckCircle, faCheck, faTimesCircle, faInfoCircle, faSignOutAlt, faEye, faEyeSlash, faLink, faCalendar, faChevronDown, faPenNib, faPen, faTrashAlt, faSquare, faThLarge, faSync, faDownload, faBars, faVectorSquare, faArrowUp, faArrowDown, faChevronUp, faCaretUp, faPlusSquare, faMinusSquare, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { faClock, faCommentAlt, faCheckCircle as farCheckCircle, faCircle, faSquare as farSquare } from '@fortawesome/free-regular-svg-icons';

function addIcons(){
  library.add(
    faArrowLeft,
    faArrowRight,
    faChevronLeft,
    faChevronRight,
    faEllipsisH,
    faMinus,
    faPlus,
    faTimes,
    faCaretDown,
    faCaretRight,
    faFlag,
    faLandmark,
    faCity,
    faList,
    faMapMarkedAlt,
    faSort,
    faSortUp,
    faSortDown,
    faSearch,
    faFilter,
    faMapMarkerAlt,
    faUserCircle,
    faPhoneAlt,
    faEnvelope,
    faUpload,
    faRedo,
    faCheck,
    faCheckSquare,
    faCheckCircle,
    faTimesCircle,
    faInfoCircle,
    faSignOutAlt,
    faEye,
    faEyeSlash,
    faLink,
    faCalendar,
    faClock,
    faCommentAlt,
    faChevronDown,
    farCheckCircle,
    faCircle,
    faSquare,
    farSquare,
    faPenNib,
    faPen,
    faTrashAlt,
    faThLarge,
    faSync,
    faDownload,
    faBars,
    faVectorSquare,
    faArrowUp,
    faArrowDown,
    faChevronUp,
    faCaretUp,
    faPlusSquare,
    faMinusSquare,
    faExclamationCircle
  );
};

export default addIcons;